import React from 'react';

export const Fleche = () => (
  <svg className="fleche" width="14" height="10" viewBox="0 0 14 10" aria-hidden="true">
    <path d="M9 1l4 4-4 4M13 5H0" fill="none" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

export const Chevron = () => (
  <svg width="10" height="6" viewBox="0 0 12 8" aria-hidden="true">
    <path d="M1 1l5 5 5-5" fill="none" stroke="currentColor" strokeWidth="1.6" />
  </svg>
);

export default Fleche;
